import {
  Activity, BadgeCheck, BriefcaseMedical, Building2, CircleDollarSign,
  ClipboardCheck, FileChartColumn, FileText, Gauge, HeartPulse, HelpCircle,
  Hospital, LayoutGrid, ReceiptText, Settings, ShieldCheck, Stethoscope,
  Users, WalletCards,
} from "@lucide/vue";

const icons = {
  advisory: Activity, auth: ShieldCheck, billing: ReceiptText, claim: FileText,
  client: Building2, compliance: BadgeCheck, encounter: Stethoscope,
  enrollee: Users, finance: CircleDollarSign, help: HelpCircle,
  hod: ClipboardCheck, home: Gauge, hospital: Hospital, invoices: ReceiptText,
  list: Users, members: Users, payment: WalletCards, private: Building2,
  provider: BriefcaseMedical, public: Building2, report: FileChartColumn,
  retail: Building2, settings: Settings, supervisor: ClipboardCheck,
  tariffMini: FileText, tariffPlus: FileText, tpa: HeartPulse,
};

export const moduleIcon = (name) => icons[name] || LayoutGrid;
